import { STATICLANGUAGEURL, STATICLANGUAGEWINDOW, KEY_DEFAULT_SEARCH_COUNTRY_CODE, KEY_DEFAULT_SEARCH_DEST_CODE, STATICREVIEWURL } from '../core/Const';
import { HotelBedCatalogData } from '../shared/index';
import { getAjaxhelper } from './CoreAjaxHelper';
import { CoreComponentAjaxUtils } from './CoreComponentAjaxUtils';
export interface TableCatalogMetadats {
    languageTableName: string;
    includeModelName: string;
} 
/**
 * Get Search Destinations
 * 
 */

export function getSearchDestinations(defDestinations: boolean, lang: string, srcKey: string): Promise<HotelBedCatalogData.DestinationsFull[]> {
    return new Promise<HotelBedCatalogData.Destinations[]>((accept: (n: any) => any, ) => {
        const defCountry: string = window[KEY_DEFAULT_SEARCH_COUNTRY_CODE];
        const defDes: string = window[KEY_DEFAULT_SEARCH_DEST_CODE];
        let where: any = {
            viewName: { $like: '%' + srcKey + '%' }
        };
        if (defDestinations) {
            where = { 
                countryCode: { $eq: defCountry },
                destinationsCode: { $eq: defDes },
                zoneCode: { $eq: null }
            };
        }
        getAjaxhelper().post(`/dynamics/rest-api/generic/DestinationsFull`, {
            "pageSize": 20,
            "eraseAuditTrail": true,
            q: where
        }).then(
            (d: any) => {
                // console.log(d);
                if (d.count === 0) {
                    getAjaxhelper().post(`/dynamics/rest-api/generic/DestinationsFull`, {
                        "pageSize": 20,
                        "eraseAuditTrail": true,
                        q: where,
                        order: ['categoryCode']
                    }).then(
                        (e: any) => {
                            accept(d.rows);
                        }
                    ).catch((exc) => { console.error('error: ', exc); });
                } else {
                    accept(d.rows);
                }

            }).catch((exc) => { console.error('error: ', exc); });

        return;
    });
} 

export function getTestimonial(): Promise<any> {
    return new Promise<any>(async (accept: (n: any) => any, ) => {
        const res = await fetch(`${STATICREVIEWURL}/testimonial.json`);
        let res2: any = {};
        if (res && res.status === 200 ) {
            res2 = await res.json();
        } 
        // window[STATICLANGUAGEWINDOW] = (res2);
        // console.log("STATICLANGUAGEWINDOW", lang, window[STATICLANGUAGEWINDOW]);
        accept(res2);
    });
}

export function updateLanguageWindow(lang: string): Promise<any> {
    return new Promise<any>(async (accept: (n: any) => any, ) => {
        const res = await fetch(`${STATICLANGUAGEURL}/${lang}.json`);
        let res2: any = {};
        if (res  && res.status === 200 ) {
            res2 = await res.json();
        } 
        window[STATICLANGUAGEWINDOW] = (res2); 
        accept(res2);
    });
}

export function getStaticPage(lang: string, slug: string): Promise<any> {
    return new Promise<any>(async (accept: (n: any) => any, ) => {
        let urlFetch = `https://storage.googleapis.com/balihotelsandmore/${lang}/static-pages${slug}.html`;
        //  console.log("urlFetch", urlFetch);
        $.ajax(urlFetch).done(
            data => {
                // console.log("CONTENT STATIC", data);
                accept(data);
            }
        ).fail(
            data => {
                urlFetch = `https://storage.googleapis.com/balihotelsandmore/ENG/static-pages${slug}.html`;
                $.ajax(urlFetch).done(
                    dnewata => {
                        // console.log("CONTENT STATIC", dnewata);
                        accept(dnewata);
                    }
                );
            }
        );
    });

}

export function getContentFronStorage(lang: string, typ: string): Promise<any[]> {
    let mainUrl = STATICLANGUAGEURL;
    let types = {
        "CmsBlog" : "CmsBlog",
        "CmsDestinationsZones": "CmsDestinationsZones",
        "CmsHomeBanner": "CmsHomeBanner",
        "CmsHotelSegment": "CmsHotelSegment",
        "CmsPromotion": "CmsPromotion",
        "CmsWithLocal": "CmsWithLocal",
        "Currency": "Currency"
    };

    let type = types[typ];

    return new Promise<any[]>((accept: (n: any) => any, ) => {
        let urlFetch = `${mainUrl}/${lang}/${type}.json`;
        // console.log("urlFetch", urlFetch);
        $.ajax(urlFetch).done(
            data => { 
                accept(data);
            }
        ).fail(
            data => {
                urlFetch = `${mainUrl}/ENG/${type}.json`;
                $.ajax(urlFetch).done(
                    dnewata => { 
                        accept(dnewata);
                    }
                );
            }
        );
        return;
    });
}
/*
export function getCmsDestinationsZones(lang: string): Promise<CMS.CmsDestinationsZones[]> {
    return new Promise<CMS.CmsDestinationsZones[]>((accept: (n: any) => any, ) => {
        getAjaxhelper().post(`/dynamics/rest-api/generic/CmsDestinationsZones`, {
            eraseAuditTrail: true,
            q: {
                homepage: { $eq: 1 }
            }
        }).then((data) => {
            accept(data.rows);
        }).catch(exc => {
            console.log(exc);
        });

        return;
    });
}
*/
/**
 * key untuk cached hotel category
 */
const HOTEL_CATEGORY_KEY: string = 'CACHED_HOTEL_CATEGORY';

/**
 * hanya membaca data category dari cache
 */
export function getOnlyFromCacheHotelCategoryCatalog(): { [id: string]: HotelBedCatalogData.Category } {
    return window[HOTEL_CATEGORY_KEY] as any;
}
/**
 * membaca cache atau request dari hotel category catalog
 */
export function getFromCacheOrRequestHotelCategoryCatalog(): Promise<{ [id: string]: HotelBedCatalogData.Category }> {
    return new Promise<{ [id: string]: HotelBedCatalogData.Category }>(async (accept: (n: any) => any, reject: (exc: any) => any) => {
        //
        if (window[HOTEL_CATEGORY_KEY]) {
            accept(window[HOTEL_CATEGORY_KEY]);
            return;
        }
        const r: HotelBedCatalogData.Category[] = await new CoreComponentAjaxUtils(getAjaxhelper()).getPagedDataWithPromise({
            modelName: 'Category',
            page: 0,
            pageSize: 50
        }) as any;
        const rtvl: { [id: string]: HotelBedCatalogData.Category } = {};
        window[HOTEL_CATEGORY_KEY] = rtvl;
        if (r && r.length > 0) {
            for (let r1 of r) {
                rtvl[r1.code!] = r1;
            }
        }
        accept(rtvl);
    });
}


// WEBPACK FOOTER //
// ./src/utils/master-data-adapter.ts